<template>
  <j-modal
    :title="title"
    :width="650"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
    dialogClass="resize-for-mobile"
  >
    <a-spin :spinning="loading">
      <!-- form 
      @keyup.enter.native="handleOk"-->
      <a-form :form="form" @keyup.enter.native="handleOk" layout="vertical">
        <!-- 施設種類名称 -->
        <a-form-item :label="this.$t('disp.facilityTypeName')">
          <!-- 施設種類名称を入力してください -->
          <a-input
            :placeholder="this.$t('disp.facilityTypeNameI')"
            v-decorator="['facilityTypeName', validatorRules.facilityTypeName]"
            :maxLength="90"
          />
        </a-form-item>
        <!-- 使用部门 -->
        <a-form-item :label="this.$t('disp.facilityTypeDeparts')">
          <j-input-popup
            v-decorator="['facilityTypeDeparts']"
            component="SelectExternalDepartModal"
            :placeholder="this.$t('disp.facilityTypeDepartsI')"
            :params="{
              companyId: '',
              departName: '',
              multiFlg: '1',
              departFlg: '1',
              searchFlg: '0',
            }"
          ></j-input-popup>
        </a-form-item>
        <!-- 备注
        placeholder="备注を入力してください"-->
        <a-form-item :label="this.$t('disp.note')">
          <a-textarea
            :rows="5"
            @keyup.enter.stop
            v-decorator="['memo']"
            :maxLength="255"
            style="resize: none"
            :placeholder="this.$t('disp.memoInput')"
          />
        </a-form-item>
        <!-- ソート順 -->
        <a-form-item :label="$t('disp.sort')">
          <j-input-number
            style="width: 95px"
            :placeholder="$t('disp.sort')"
            v-decorator="['sortOrder', validatorRules.sortOrder]"
            @change="sortOrderChange"
            :min="0"
            :max="999"
          />
        </a-form-item>
      </a-form>
    </a-spin>
  </j-modal>
</template>

<script>
import pick from 'lodash/pick'
import { addRole, editRole, duplicateCheck } from '@/api/api'
import { httpAction, getAction, postAction, putAction } from '@/api/manage'
import JInputNumber from '@/components/JInputNumber'

export default {
  name: 'FacilityTypeModal',
  components: {
    // JInputNumber
    JInputNumber,
  },
  data() {
    return {
      //   	③フォーカスアウト
      // 属性チェック：シート「画面項目説明」を参照
      // 業務チェック：なし
      // 処理仕様：			なし
      // 項目編集：なし
      // タイトル
      title: '',
      // 表示制御
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      // ローディング
      loading: false,
      // フォーム
      form: this.$form.createForm(this),
      // ルール
      validatorRules: {
        // 施設名称
        facilityTypeName: {
          // 必要
          rules: [
            {
              required: true,
              message: this.$t('disp.rules.require'),
            },
            {
              // チェックルール
              validator: this.validateFacilityTypeName,
            },
          ],
        },
        // ソート
        sortOrder: { initialValue: 1.0 },
        description: {},
      },
    }
  },
  methods: {
    // ②「確定」ボタンをクリックする
    // 	属性チェック：シート「画面項目説明」を参照
    // 	業務チェック：
    // 	施設種類名称の重複存在チェックを行う。
    validateFacilityTypeName(rule, value, callback) {
      if (!value) {
        callback()
      } else {
        let params = {
          // テーブル名
          tableName: 'sys_facility_type',
          // fieldName
          fieldName: 'FACILITY_TYPE_NAME',
          // fieldVal
          fieldVal: value,
          // id
          dataId: this.model.id,
        }
        // 存在するの場合、処理終了、メッセージを表示します。
        // パラメータ					内容
        // 施設種類名称					画面.施設種類名称
        // ID：msg.E_K0402001_01
        // 内容：施設種類名称が重複しているレコードが存在します。
        duplicateCheck(params).then((res) => {
          res.success ? callback() : callback(this.$t('disp.rules.duplicate', [this.$t('disp.facilityTypeName')]))
        })
      }
    },
    /**
     * @description ソート順が空白の場合
     */
    sortOrderChange(e) {
      if (e == '' || e == null) {
        this.$nextTick(() => {
          this.form.setFieldsValue({
            sortOrder: 0,
          })
        })
      }
    },
    // 新規
    add() {
      this.edit({})
    },
    // 編集
    edit(record) {
      this.form.resetFields()

      this.model = Object.assign({}, record)
      // 设置使用部门
      if (this.model.facilityTypeDeparts && this.model.facilityTypeDeparts.length > 0) {
        this.model.facilityTypeDeparts.forEach((item) => {
          item.value = item.systemCode + '_' + item.departId
          item.text = '[' + item.systemName + ']' + item.departName
        })
      }
      // 表示する
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'facilityTypeName', 'facilityTypeDeparts', 'memo', 'sortOrder'))
      })
    },
    // 閉じる
    close() {
      this.$emit('close')
      // 非表示にする
      this.visible = false
    },
    // 項目編集：
    // 新規登録の場合
    // 画面タイトル：追加
    handleOk() {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }
      const that = this
      // チェックする
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          let formData = Object.assign(this.model, values)
          // formData.facilityTypeDepartIds = XEUtils.map(formData.facilityTypeDeparts, (item) => item.value).join(',')
          if (formData.facilityTypeDeparts && formData.facilityTypeDeparts.length > 0) {
            formData.facilityTypeDeparts = XEUtils.map(formData.facilityTypeDeparts, (item) => {
              return {
                departId: item.originalId ? item.originalId : item.departId,
                departName: item.departName,
                orgCode: item.orgCode,
                systemCode: item.systemCode,
                systemName: item.systemName,
                sortOrder: item.sortOrder,
              }
            })
          } else {
            formData.facilityTypeDeparts = []
          }

          let obj
          if (!this.model.id) {
            // 追加の場合
            let url = '/kgms/k04/FacilitiesManage/addFacilityType'
            postAction(url, formData)
              .then((res) => {
                // 成功
                if (res.success) {
                  // メッセージ：追加しました。
                  that.$message.success(this.$t(res.message))
                  that.$emit('emit')
                }
              })
              .finally(() => {
                // ローディング終了
                that.loading = false
                // 画面閉じる
                that.close()
              })
          } else {
            // 更新編集の場合
            // 画面タイトル：				編集
            // 施設種類名称： 				施設種類情報.施設種類名称
            // 备注： 施設種類情報.备注
            // ソート順： 施設種類情報.ソート順
            // PK_ID（隠し）：施設種類情報.PK_ID
            let url = '/kgms/k04/FacilitiesManage/editFacilityType'
            putAction(url, formData)
              .then((res) => {
                // 成功
                if (res.success) {
                  // メッセージ：編集しました。
                  that.$message.success(this.$t(res.message))
                  that.$emit('emit')
                }
              })
              .finally(() => {
                // ローディング終了
                that.loading = false
                // 画面閉じる
                that.close()
              })
          }
        } else {
          // ローディング終了
          that.loading = false
        }
      })
    },
    // キャンセル
    handleCancel() {
      // 画面閉じる
      this.close()
    },
  },
}
</script>

<style scoped></style>
